import { createAction } from '../utils';
export var LOAD_TASKS = '[BPMN] load tasks';
export var LOAD_TASKS_SUCCESS = '[BPMN] load tasks success';
export var LOAD_TASKS_ERROR = '[BPMN] load tasks error';
// BPMN tasks
export var fetchTasksAction = function (payload) { return createAction(LOAD_TASKS, payload); };
export var fetchTasksSuccessAction = function (payload) { return createAction(LOAD_TASKS_SUCCESS, payload); };
export var fetchTasksErrorAction = function (payload) { return createAction(LOAD_TASKS_ERROR, payload); };
//# sourceMappingURL=actions.js.map